import { render, staticRenderFns } from "./ParentalLeaveTable.vue?vue&type=template&id=8be5ef42&"
import script from "./ParentalLeaveTable.vue?vue&type=script&lang=js&"
export * from "./ParentalLeaveTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports